// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const PenSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 178 178"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path fill="none" d="M0 0h177.63v177.63H0z" />
      <path
        d="M136.42 16.381L17.102 133.42l-1.006 29.53 26.452 1.593L162.166 42.904 136.42 16.381z"
        fill="none"
        stroke={props.fill}
        strokeWidth={10}
      />
      <path
        d="M109.577 42.711l26.661 26.56"
        fill="none"
        stroke={props.fill}
        strokeWidth={10}
        strokeLinecap="butt"
      />
    </svg>
  )
}
